import Vue from 'vue'
import VueRouter from 'vue-router'
import PageIndex from './page/PageIndex.vue'
import PageHistory from './page/PageHistory.vue'
import PageInfo from './page/PageInfo.vue'
import PageLogin from './admin/PageLogin.vue'
import PageHome from './admin/PageHome.vue'
import PageDown from './page/PageDown.vue'

Vue.use(VueRouter)

const userRoutes = [
  { path: 'index', name: 'userIndex', component: PageIndex },
  { path: 'history', name: 'history', component: PageHistory },
  { path: 'info', name: 'info', component: PageInfo },
  { path: 'download', name: 'download', component: PageDown },
]

const adminRoutes = [
  { path: 'login', name: 'adminLogin', component: PageLogin },
  { path: 'home', name: 'home', component: PageHome },
]

// 👉 这个写法是 OK 的（匿名 layout）
const EmptyLayout = { render: h => h('router-view') }

const routes = [
  { path: '/users', component: EmptyLayout, children: userRoutes },
  { path: '/AWEGADEX', component: EmptyLayout, children: adminRoutes },

  // ❗ Vue Router 3 推荐写法（Vue2）
  { path: '*', redirect: '/users/index' }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router